var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "patternmaker-patternmaker-view-thumbnails"
  }, [_vm.enableSwiper ? _c('div', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper"
  }, [_c('swiper', {
    ref: "swiper",
    class: ['patternmaker-patternmaker-view-thumbnails-wrapper-swiper', {
      'patternmaker-patternmaker-view-thumbnails-wrapper-swiper--no-loop': !_vm.swiperOptions.loop
    }],
    attrs: {
      "options": _vm.swiperOptions,
      "auto-update": false,
      "cleanup-styles-on-destroy": true
    },
    on: {
      "touchEnd": _vm.swatchTouched
    }
  }, _vm._l(_vm.swatches, function (item, index) {
    return _c('swiper-slide', {
      key: index,
      class: ['patternmaker-patternmaker-view-item', {
        active: item.id === _vm.currentSwatch,
        disabled: !_vm.enabled
      }],
      attrs: {
        "data-swatch-id": item.id
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.id === _vm.currentSwatch,
        expression: "item.id === currentSwatch"
      }],
      staticClass: "icon-check"
    }), item.thumb ? _c('img', {
      staticClass: "background",
      attrs: {
        "src": item.thumb,
        "alt": item.display_name.default,
        "data-swatch-id": item.id
      }
    }) : _vm._e(), item.color ? _c('div', {
      staticClass: "background",
      style: "background-color: ".concat(item.color),
      attrs: {
        "data-swatch-id": item.id
      }
    }) : _vm._e()]);
  }), 1), _c('div', {
    class: ['patternmaker-patternmaker-view-thumbnails-wrapper-nav-wrapper', {
      'hide': !_vm.enableCarouselNavigation
    }]
  }, [_c('button', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-previous swatches",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-left-indicator-open",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  })]), _c('button', {
    staticClass: "patternmaker-patternmaker-view-thumbnails-wrapper-nav-button-next swatches",
    attrs: {
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-arrow-right-indicator-open",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })])])], 1) : _c('base-spinner', {
    ref: "spinner",
    attrs: {
      "size": "50",
      "position": "inherit"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }